/** biome-ignore-all lint/correctness/useUniqueElementIds: error/warn id's are unique*/
import { Link } from '@tanstack/react-router'
import { Menu } from 'lucide-react'
// import { Menu } from 'lucide-react'
import Logo from '@/components/layout/logo/gsma'
import {
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerTrigger,
} from '@/components/ui/drawer'

export default function Header() {
	return (
		<header className="@container bg-gsma-red-1 flex h-[58px] w-full items-center justify-start text-white md:h-[88px] p-4">
			<div className=" flex items-center justify-start @7xl:mx-auto w-full max-w-[1280px] gap-2">
				<a
					id="layout_skip-to-content"
					href="#wrapper"
					className="text-primary-content absolute left-20 m-3 -translate-y-20 rounded-none bg-black p-3 transition focus:translate-y-0"
					data-pagefind-ignore
				>
					{' '}
					Skip to Content
				</a>

				<Link
					id="layout_home-link"
					to={'/'}
					className="flex items-center justify-start gap-4 text-white"
				>
					<Logo className="h-4 w-fit fill-white " />
					<span className="text-2xl  md:text-2xl font-semibold ">
						Open Gateway
					</span>
				</Link>
			</div>
			<MobileMenu />
		</header>
	)
}

function MobileMenu() {
	return (
		<Drawer direction="right">
			<DrawerTrigger className="hover:cursor-pointer">
				<Menu className=" h-7 w-7 " />
			</DrawerTrigger>
			<DrawerContent className="bg-gsma-red-2 ">
				<nav>
					<ul className="flex flex-col gap-0 px-0  w-full">
						<li className="w-full">
							<DrawerClose asChild>
								<Link
									to={'/'}
									className="text-white text-lg font-medium w-full inline-block hover:bg-gsma-red-3 pl-4 py-4"
								>
									Home
								</Link>
							</DrawerClose>
						</li>
						<li className="w-full">
							<DrawerClose asChild>
								<a
									// to={'/enablement'}
									href="/enablement"
									target="_blank"
									rel="noopener"
									className="text-white text-lg font-medium w-full inline-block hover:bg-gsma-orange-dark pl-4 py-4"
								>
									Channel Partner Readiness Map
								</a>
							</DrawerClose>
						</li>
						<li className="w-full">
							<DrawerClose asChild>
								<a
									// to={'/demand'}
									href="/demand"
									target="_blank"
									className="text-white text-lg font-medium  w-full inline-block hover:bg-gsma-cyan-dark pl-4 py-4"
									rel="noopener"
								>
									Enterprise Demand Map
								</a>
							</DrawerClose>
						</li>
					</ul>
				</nav>
				{/* <DrawerHeader>
					<DrawerTitle>Are you absolutely sure?</DrawerTitle>
					<DrawerDescription>
						This action cannot be undone.
					</DrawerDescription>
				</DrawerHeader> */}
				{/* <DrawerFooter>
					<Button>Submit</Button>
					<DrawerClose>
						<Button variant="outline">Cancel</Button>
					</DrawerClose>
				</DrawerFooter> */}
			</DrawerContent>
		</Drawer>
	)
}
